function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export const ProductAnalyticsEvent = {
    WorkspaceSelected: 'workspace selected',
    CommandPaletteOpened: 'command palette opened',
    DeploymentIntegrationsOpened: 'deployment integrations opened',
    EnvironmentCustomDomainViewed: 'environment custom domain viewed',
    EnvironmentCustomDomainConnectClicked: 'environment custom domain connect clicked',
    EnvironmentCustomDomainBlockedViewed: 'environment custom domain blocked viewed',
    EnvironmentCustomDomainBlockedLearnMoreClicked: 'environment custom domain blocked learn more clicked'
};
let activeProductAnalyticsSender = null;
export function setProductAnalyticsSender(sender) {
    activeProductAnalyticsSender = sender;
}
export function createPostHogAnalyticsSender(client) {
    let defaultProperties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (event, properties)=>{
        client.capture(event, _object_spread({}, defaultProperties, properties));
    };
}
export function trackProductAnalyticsEvent(event, properties) {
    if (!activeProductAnalyticsSender) {
        return;
    }
    activeProductAnalyticsSender(event, properties);
}
export function trackCustomProductAnalyticsEvent(event) {
    let properties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!activeProductAnalyticsSender) {
        return;
    }
    activeProductAnalyticsSender(event, properties);
}
